import { httpHkPost2 } from '@/utils/httpHk'

let deviceFingerprintPromise: Promise<string> | null = null
let fallbackDeviceUserId = ''
const DEVICE_USER_ID_STORAGE_KEY = 'promotionBehaviorDeviceUserId'

function createFallbackDeviceUserId() {
  const randomPart = Math.random().toString(36).slice(2)
  return `device-${Date.now().toString(36)}-${randomPart}`
}

function getFallbackDeviceUserId() {
  if (fallbackDeviceUserId)
    return fallbackDeviceUserId

  try {
    const storedUserId: unknown = uni.getStorageSync(DEVICE_USER_ID_STORAGE_KEY)
    if (typeof storedUserId === 'string' && storedUserId.trim()) {
      fallbackDeviceUserId = storedUserId
      return fallbackDeviceUserId
    }

    fallbackDeviceUserId = createFallbackDeviceUserId()
    uni.setStorageSync(DEVICE_USER_ID_STORAGE_KEY, fallbackDeviceUserId)
  }
  catch (error) {
    console.warn('[promotionBehavior] fallback device ID storage failed:', error)
    fallbackDeviceUserId = createFallbackDeviceUserId()
  }

  return fallbackDeviceUserId
}

async function getPromotionBehaviorUserId(): Promise<string> {
  // #ifdef H5
  if (!deviceFingerprintPromise) {
    deviceFingerprintPromise = (async () => {
      const { getDeviceFingerprint } = await import('@/utils/deviceFingerprint')
      return getDeviceFingerprint()
    })()
  }

  try {
    const userId = await deviceFingerprintPromise
    if (userId?.trim())
      return userId.trim()
  }
  catch (error) {
    deviceFingerprintPromise = null
    console.warn('[promotionBehavior] FingerprintJS failed; using stored device ID:', error)
  }
  // #endif

  return getFallbackDeviceUserId()
}

export async function savePromotionExposure(channelId: string, _isLoggedIn: boolean) {
  const userId = await getPromotionBehaviorUserId()
  if (!userId) {
    deviceFingerprintPromise = null
    throw new Error('Promotion exposure requires a device user ID')
  }

  return httpHkPost2<unknown>('/ecom/promotionBehaviorLog/saveForExposure', {
    channelId,
    userId,
  })
}

export async function savePromotionDownload(channelId: string) {
  const userId = await getPromotionBehaviorUserId()
  if (!userId) {
    deviceFingerprintPromise = null
    throw new Error('Promotion download requires a device user ID')
  }

  return httpHkPost2<unknown>('/ecom/promotionBehaviorLog/saveForDownload', {
    channelId,
    userId,
  })
}
